import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { DashboardService } from '../../../api/dashboard/dashboard.service';
declare var $: any;
declare var jQuery: any;
@Component({
    selector: 'dailyreport-page',
    templateUrl: './dailyreport.html'
})
export class DailyReportComponent implements OnInit {
    DateValue: string = "7";
    userrptList: any;
    roleType: string;
    progressPer :string = "0%";
    countrywiseList : any;
    constructor(
        private dashboardService: DashboardService,
        private router: Router
    ) {
    }
    ngOnInit() {
        if (localStorage.getItem('id_token') && (localStorage.getItem('type') == 'SUPERADMIN' || localStorage.getItem('type') == 'ADMIN'  || localStorage.getItem('type') == 'GENEROSITY')) {
            $('.nav-item a').click(function () {
                $('a.nav-link.active').removeClass('active')
                $('a.nav-link').addClass('nav-link');
                $(this).addClass("active");
            });
            $(function () {
                $("[data-toggle=popover]").popover();
                $("[data-toggle=popover-hover]").popover({
                    trigger: 'hover'
                });
                $("[data-toggle=tooltip]").tooltip();
            });
            this.progressPer = "0%";
            this.countrywiseList = [];
            this.DateValue = "7";
            this.roleType = localStorage.getItem("type");
            this.initDay();
        }
        else {
            this.router.navigate(['/']);
        }
    }
    register_device = {
        // register_Oppo: "0",
        // register_Mi: "0",
        // register_Vivo: "0",
        // register_Amazon: "0",
        // register_Huawei: "0",
        register_Google: "0",
        // register_One: "0",
        // register_Samsung: "0",
        // register_UpToDown: "0",
        // register_Shareit: "0",
        // register_Jio: "0",
        // register_ApkPure: "0",
        // register_ApkMirror: "0",
        // register_ApkMonk: "0",
        // register_BeMobi: "0",
        register_iOS: "0"
    };
    active_device = {
        // active_Oppo: "0",
        // active_Mi: "0",
        // active_Vivo: "0",
        // active_Amazon: "0",
        // active_Huawei: "0",
        active_Google: "0",
        // active_One: "0",
        // active_Samsung: "0",
        // active_UpToDown: "0",
        // active_Shareit: "0",
        // active_Jio: "0",
        // active_ApkPure: "0",
        // active_ApkMirror: "0",
        // active_ApkMonk: "0",
        // active_BeMobi: "0",
        active_iOS: "0"
    };
    showRegisterDeviceSubType(data) {
        this.register_device = data;
    }
    showActiveDeviceSubType(data) {
        this.active_device = data;
    }
    initDay() {
        this.progressPer = "35%";
        var JDDD = {
            days: this.DateValue
        }
        this.dashboardService.dailyreport(JDDD).then(data => {
            this.progressPer = "100%";
            this.userrptList = data.data;
            var nologin_activeuser_report = data.nologin_activeuser_report;
            for (let index = 0; index < this.userrptList.length; index++) {
                const element = this.userrptList[index];
                var _date = new Date(element.createdAta);
                var freecounter = "";
                var paidcounter = "";
                var dailyDate = this.convertDate(_date);
                const result = nologin_activeuser_report.filter((word) => word.date == dailyDate);
                if(result.length > 0)
                {
                    freecounter = result[0].free.toString();
                    paidcounter = result[0].paid.toString();
                }
                element.freecounter = freecounter;
                element.paidcounter = paidcounter;
                element.totalactivelogin = parseInt(element.active_facebook_login) + parseInt(element.active_apple_login) + parseInt(element.active_google_login) + parseInt(element.active_huawei_login)+ parseInt(element.active_email_login);
                element.totalactivedevice = parseInt(element.active_android_device) + parseInt(element.active_ios_device) + parseInt(element.active_huawei_device);
            }
            this.progressTimeOut();
        }
        );
    }
    convertDate(date) {
        if (date == null) {
          date = new Date();
        }
        var yyyy = date.getFullYear().toString();
        var mm = (date.getMonth() + 1).toString();
        var dd = date.getDate().toString();
        var mmChars = mm.split('');
        var ddChars = dd.split('');
        return (ddChars[1] ? dd : "0" + ddChars[0]) + '-' + (mmChars[1] ? mm : "0" + mmChars[0]) + '-' + yyyy;
      }
    onDateChange(dChange) {
        this.DateValue = dChange;
        this.initDay();
    }

    countrywisefilter(data)
    {
        this.progressPer = "35%";
        var _date = new Date(data.createdAta);
        var month = _date.getUTCMonth() + 1; //months from 1-12
        var day = _date.getUTCDate();
        var year = _date.getUTCFullYear();
        var newdate = year + "-" + month + "-" + day;
        var JDDD = {
            date: newdate
        }
        this.dashboardService.daywisecountryreport(JDDD).then(data => 
            {
                this.progressPer = "100%";
                this.countrywiseList = data.data;
                $(function () 
                {
                    $("#countrywiselistModal").modal('toggle');
                });
                this.progressTimeOut();
            }
        );
    }
    progressTimeOut()
    {
      setTimeout(()=>
      { 
        this.progressPer = "0%"; 
      },200);
    }

    nologinBackup()
    {
        this.progressPer = "50%";
        this.dashboardService.nologin_activeuser_report_backup().then(data => 
            {
                this.progressPer = "100%";
                $.notify({
                    message: data.message
                }, {
                    type: 'success',
                    placement: {
                        from: 'bottom',
                        align: 'left'
                    },
                    delay: 100,
                    timer: 100
                });
                this.progressTimeOut();

            }
        );
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/dailyreport/dailyreport.page.ts